import { createContext } from 'react';

export interface TenantContextValue {
  tenant: string;
  isValidTenant: boolean;
}

export const TenantContext = createContext<TenantContextValue | null>(null);
